import { Component, OnInit, ViewChild, Input, Output, HostListener, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import * as _ from 'lodash';
import { TimeSheetService } from '../../services/time-sheet.service';
import { trigger, transition, useAnimation } from '@angular/animations';
import { flipInX } from 'ng-animate';
import { saveAs } from "file-saver";
import { IfStmt } from '@angular/compiler';

// import { MatSnackBar } from '@angular/material/snack-bar';

export const FLIP_TRANSITION = [
  trigger('flipInX', [transition('* => *', useAnimation(flipInX, {
    params: { timing: 0.5, delay: 0 }
  }))]),
  // trigger(
  //   'inOutAnimation',
  //   [
  //     transition(
  //       ':enter',
  //       [
  //         style({ opacity: 0 }),
  //         animate('5s ease-in-out',
  //           style({ opacity: 1 }))
  //       ]
  //     ),
  //     transition(
  //       ':leave',
  //       [
  //         style({ opacity: 1 }),
  //         animate('5s ease-in',
  //           style({ opacity: 0 }))
  //       ]
  //     )
  //   ]
  // ),
  // trigger('flipInX', [transition('* => *', useAnimation(flip))]),
];




@Component({
  selector: 'app-single-week',
  templateUrl: './single-week.component.html',
  styleUrls: ['./single-week.component.scss'],
  animations: [FLIP_TRANSITION]
})
export class SingleWeekComponent implements OnInit {

  @Input('instFromAdminReport') instFromAdminReport;
  @Input('calWeekDates') doGetWeekDates;
  @Input('logsFromAdmin') logsFromAdmin;
  @Input('overTimeHours') overTimeHours;
  @Input('datesFromInstructor') datesArrayFromInst;
  @Input('weekDatesFromAdmin') weekDatesFromAdmin;
  @Input('monthChanged') monthChanged;
  @Input('instDetails') instDetails;
  @Output() print: EventEmitter<any> = new EventEmitter<any>();
  totalHoursWorked = { hours: 0, minutes: 0 };
  pageSizeOptions: number[] = [25, 50, 100];
  jobId;
  displayedColumns: string[] = ['copyPaste', 'nightShift', 'date', 'logIn', 'lunchStart', 'lunchEnd', 'logOut', 'travelHours', 'hoursWorked', 'totalHours', 'edit', 'reset'];
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  currentTime;
  totalHours = 0;
  totalMinutes = 0;
  datesOfWeek;
  Days: any = [];
  finalArray: any = [];
  showTotalHoursColor = true;
  exportShows: boolean = false;
  export: boolean = false;

  arrayFromDb: any = [];
  arrayFromParam: any = [];
  queryParamsObj = {};
  instructorId: any;
  displayMsg: boolean = false;
  displayNoDataMsg: boolean;
  loading: boolean = false;
  currentUser: any;
  displayTitle: boolean = true;
  copiedLogs = {
    logIn: '',
    lunchStart: '',
    lunchEnd: '',
    logOut: '',
    travel: ''
  }

  overH = 0;
  overM = 0;
  showPasteBtn: boolean = false;
  copiedIndex: any;
  isPrint: boolean = false;
  editing: boolean = false;
  index: any;
  editedIndex = [];
  deletedLog = [];
  p: Number = 1;
  currentPage: any = 0;
  instName: any;
  instEmail: any;
  periodStart: any;
  periodEnd: any;
  regularHours: number = 0;
  workWeekHours: Number;
  overTime: string = "00:00";
  totalTravelNWork: string;
  hideActions: boolean;
  demoTime;
  selectedDate

  // Page Variables

  public pageSize = 10;
  public pageIndex = 0;
  public totalSize = 0;
  pageEvent: any;


  chooseDateMsg = {
    title: 'No Logs!',
    data: 'Please choose dates to display time logs'
  }
  user: any;





  // Days = [
  //   { id: '0', date: '02/11/2020', logIn: '00:00', lunchStart: '00:00', lunchEnd: '00:00', logOut: '00:00', workingHours: { hours: 0, minutes: 0 }, travelHours: '00:00', day: 'Sunday', checked: false },
  //   { id: '1', date: '02/12/2020', logIn: '00:00', lunchStart: '00:00', lunchEnd: '00:00', logOut: '00:00', workingHours: { hours: 0, minutes: 0 }, travelHours: '00:00', day: 'Monday', checked: false },
  //   { id: '2', date: '02/13/2020', logIn: '00:00', lunchStart: '00:00', lunchEnd: '00:00', logOut: '00:00', workingHours: { hours: 0, minutes: 0 }, travelHours: '00:00', day: 'Tuesday', checked: false },
  //   { id: '3', date: '02/14/2020', logIn: '00:00', lunchStart: '00:00', lunchEnd: '00:00', logOut: '00:00', workingHours: { hours: 0, minutes: 0 }, travelHours: '00:00', day: 'Wednesday', checked: false },
  //   { id: '4', date: '02/15/2020', logIn: '00:00', lunchStart: '00:00', lunchEnd: '00:00', logOut: '00:00', workingHours: { hours: 0, minutes: 0 }, travelHours: '00:00', day: 'Thursday', checked: false },
  //   { id: '5', date: '02/16/2020', logIn: '00:00', lunchStart: '00:00', lunchEnd: '00:00', logOut: '00:00', workingHours: { hours: 0, minutes: 0 }, travelHours: '00:00', day: 'Friday', checked: false },
  // ];

  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
  }
  @HostListener('window:beforeprint', ['$event'])
  onBeforePrint(event) {
    this.isPrint = true
    $('th').addClass('printTableHeader')
    this.print.emit({ msg: 'printing' })
    this.displayedColumns = ['date', 'logIn', 'lunchStart', 'lunchEnd', 'logOut', 'travelHours', 'hoursWorked', 'totalHours'];
    this.dataSource.paginator = null;
  }

  @HostListener('window:afterprint', ['$event'])
  onAfterPrint(event) {
    this.isPrint = false
    $('th').removeClass('printTableHeader')
    this.print.emit({ msg: 'printing complete' })
    this.displayedColumns = ['copyPaste', 'date', 'logIn', 'lunchStart', 'lunchEnd', 'logOut', 'travelHours', 'hoursWorked', 'totalHours', 'edit'];
    this.dataSource.paginator = this.paginator;
  }



  constructor(private route: ActivatedRoute, private router: Router, public _timeSheetService: TimeSheetService, private _snackBar: MatSnackBar,
    private changeDetector: ChangeDetectorRef) {

    this.dataSource = new MatTableDataSource<any>();

    this.route.queryParams.subscribe(params => {
      console.log('Query Params=>', params);
      this.datesOfWeek = params.datesOfTheWeek;
      this.instructorId = params.instructorId;
    });
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    if (this.user.isAdmin == 'admin') this.displayTitle = false;
    if (this.user.isTrainer || this.user.isMp || this.user.isStaff || this.user.isIQA || this.user.isOperative) this.displayMsg = false; else this.displayMsg = true;
    // this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (this.user.isClient) {
      this.displayedColumns = ['date', 'logIn', 'lunchStart', 'lunchEnd', 'logOut', 'travelHours', 'hoursWorked', 'totalHours'];
      this.hideActions = true
    }
    // this.hideActions = (this.currentUser.userRole == 'client') ? true : false
    if (this.router.url.includes('/staff')) this.displayMsg = false;
    if (this.router.url.includes('/admin-time-sheet')) this.showTotalHoursColor = false;

    console.log("**ON INIT**", this.datesOfWeek)
    if (this.datesOfWeek) {
      this.getDays();
      this.getValuesUsingDates('test1');
    }
    else if (this.doGetWeekDates == true) {
      console.log("**On init this.instructorId", this.instructorId);
      this.instructorId = this.instFromAdminReport;
      this.displayMsg = false;
      this.selectedDate = moment().format("MM/DD/YYYY")
      this.getWeekDates();
    }
    else if (this.doGetWeekDates == false) {
      this.datesOfWeek = this.datesArrayFromInst
    }
    if (this.instDetails) {
      this.instName = this.instDetails.name
      this.instEmail = this.instDetails.email
    }

    if (this.router.url.includes('/admin-time-sheet')) {
      this.exportShows = true;
      this.export = false;
      this.getWeekDates();
    } else {
      this.export = true;
    }

    console.log('EXPORT BUTTON SHOW', this.exportShows);


  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loading = true
    console.log("Something changed", changes);
    console.log("Something changed ADMINlOGS", changes.logsFromAdmin);
    if (changes.instFromAdminReport) {
      this.instructorId = changes.instFromAdminReport.currentValue
      this.dataSource = new MatTableDataSource()
      // this.loading = true;
      this.getValuesUsingDates('test2')
    }
    else if (changes.logsFromAdmin && changes.logsFromAdmin.currentValue != 'noData') {
      this.displayMsg = false
      this.displayNoDataMsg = false
      this.Days = changes.logsFromAdmin.currentValue
      this.updateData(changes.logsFromAdmin.currentValue)
      this.totalWorkingHours();
    }
    else if (changes.logsFromAdmin && changes.logsFromAdmin.currentValue == 'noData') {
      this.loading = false
      this.displayNoDataMsg = true
      this.displayMsg = false;
    };
    if (changes.overTimeHours) this.overTimeHours = changes.overTimeHours.currentValue;
    if (changes.datesArrayFromInst && changes.datesArrayFromInst.currentValue) {
      this.datesOfWeek = changes.datesArrayFromInst.currentValue
      console.log("dates of week list===>", this.datesOfWeek)
      this.getValuesUsingDates('test3')
    }
    if (changes.weekDatesFromAdmin && changes.weekDatesFromAdmin.currentValue) {
      console.log("weekDatesFromAdmin", changes.weekDatesFromAdmin.currentValue);
      this.showPasteBtn = false
      this.periodStart = changes.weekDatesFromAdmin.currentValue[0]
      console.log("**this.periodStart", this.periodStart);
      this.periodEnd = changes.weekDatesFromAdmin.currentValue[changes.weekDatesFromAdmin.currentValue.length - 1]
      console.log("**this.periodEnd", this.periodEnd);
      this.displayMsg = false;
      this.datesOfWeek = changes.weekDatesFromAdmin.currentValue
      this.getValuesUsingDates('test4')
    }
    if ((changes.monthChanged && changes.monthChanged.currentValue == true) || changes.doGetWeekDates && changes.doGetWeekDates.currentValue == true) {
      this.getWeekDates()
    }
    if (changes.instDetails && changes.instDetails.currentValue) {
      this.instName = changes.instDetails.currentValue.name
      this.instEmail = changes.instDetails.currentValue.email
    }
  }
  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
    // this.checkTravelPlusWorkHour()
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }



  getWeekDates() {
    this.loading = false
    // console.log("**getWeekDates called")
    this.displayMsg = false;
    // console.log("-----getWeekDates-----", moment().startOf('week'), moment().endOf('week'));
    let weekStartDate = moment().startOf('week')
    let weekEndDate = moment().endOf('week')
    console.log("What is week start date", weekStartDate, weekEndDate);

    let dates = []


    // console.log("Hello here is starting Date:--", weekStartDate)
    // // return new Promise((resolve,reject)=>{
    dates.push(weekStartDate.format('MM/DD/YYYY'))
    return new Promise((resolve, reject) => {
      while (weekStartDate.add(1, 'days').diff(weekEndDate) < 0) {
        // console.log("In while loop");
        // console.log(weekStartDate.toDate());
        dates.push(weekStartDate.clone().format('MM/DD/YYYY'));
      }
      resolve(dates)
      this.datesOfWeek = dates;
      console.log("Total week days", this.datesOfWeek);


      // console.log(" AFTER WHILE **dates", dates);
      // })
    }).then((resolvedArray) => {
      this.getValuesUsingDates('test5')
    })
  }

  getDays() {
    this.updateData(this.Days);
  }

  updateData(weekDays) {
    console.log("UPDATING DATA = For Single Week ", weekDays)
    this.padZeroInLogs(weekDays)
    this.dataSource = new MatTableDataSource(weekDays);
    this.dataSource.paginator = this.paginator;
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
    this.loading = false
  }


  padZeroInLogs(logs) {
    let count = 0;
    return new Promise((resolve, reject) => {
      if (logs && logs.length) {
        logs.forEach(async folder => {
          const result = await this.padZeroInOneLog(folder);
          count++;
          if (count == logs.length) {
            // resolve()
          }
        })
      } else {
        // resolve()
      }
    })
  }

  padZeroInOneLog(log) {
    return new Promise((resolve, reject) => {
      log.logIn = this.padZero(log.logIn)
      log.lunchStart = this.padZero(log.lunchStart)
      log.lunchEnd = this.padZero(log.lunchEnd)
      log.logOut = this.padZero(log.logOut)
      log.travel = this.padZero(log.travel)
      resolve(log)
    })
  }

  padZero(value) {
    // console.log("What is the value", value);
    if (value != null) {
      const digit = value.split(':');
      let data = String(this.padString(digit[0])) + ':' + String(this.padString(digit[1]));
      return data;
    }
  }

  padString(value) {
    if (value != null) {
      if (Number(value) < 10 && value.length != 2) {
        return '0' + value;
      } else {
        return value;
      }
    }
  }

  timeChanged(event, index, control) {
    console.log("this.currentTime", event);
    let element = event.split(":")


    if (element[0] == 24) {
      this.Days[index][control] = "00:" + element[1]
    }
    console.log("This is After Update", this.Days[index]);

    // let element = this.Days[index][currentTime].split(":")
    // this.Days[index][currentTime] = '00:' + element[1]
    this.currentTime = event;
  }
  eventFromTimePicker(event) {
    console.log("eventFromTimePicker($event)", event);
  }


  nightSelected(event, index) {
    console.log("Event when checkbox is selected", event);
    console.log("Selected Day", this.Days[index]);
    let element = this.Days[index]
    if (element.logIn != '00:00' && event.checked) {
      if (element.lunchSTime == "" || element.lunchSTime != '00:00') element.lunchSTime = '00:00'
      if (element.lunchSTime == "" || element.lunchETime != '00:00') element.lunchETime = '00:00'
      if (element.lunchSTime == "" || element.logTime != '00:00') element.logTime = '00:00'
    } else {
      element.lunchSTime = element.logIn
      element.lunchETime = element.lunchStart
      element.logTime = element.lunchEnd
    }

  }


  closedTimePicker(index, preTime, currentTime, minTime, sequence) {
    console.log("index, preTime, currentTime, minTime", index, preTime, currentTime, minTime, sequence);

    if (this.Days[index][currentTime] != null && this.Days[index][currentTime].split(":")[0] == 24) {
      console.log("Call this Part");
      this.Days[index][currentTime] = "00:" + this.Days[index][currentTime].split(":")[1]
    }

    console.log("Before Calculate", this.Days[index]);

    this.setMinimumTime(index, preTime, currentTime, minTime, sequence)
    let diff
    diff = this.calculateTime(index, 'logIn', 'lunchStart')
    let diff2 = this.calculateTime(index, 'lunchEnd', 'logOut')
    console.log("Whar is the the total diff", diff, diff2);
    this.updateTimeValue(index, diff, diff2, true)

    // let diff
    // let element = this.Days[index]
    // if (sequence != 'first' && !element.createdAt) diff = this.calculateTime(index, preTime, currentTime)
    // if (sequence == 'first' && element.createdAt) {
    //   diff = this.calculateTime(index, 'logIn', 'lunchStart')
    //   let diff2 = this.calculateTime(index, 'lunchEnd', 'logOut')
    //   this.updateTimeValue(index, diff, diff2, true)
    // }
    // if (sequence == 'second' && element.createdAt) {
    //   console.log("Call this for only second step", this.Days[index]);
    //   diff = this.calculateTime(index, 'logIn', 'lunchStart')
    //   let diff2 = this.calculateTime(index, 'lunchEnd', 'logOut')
    //   console.log("Whar is the the total diff", diff, diff2);
    //   this.updateTimeValue(index, diff, diff2, true)
    // }
    // if (sequence != 'first' && currentTime != 'lunchEnd' && sequence != 'four' && !element.createdAt) this.updateTimeValue(index, diff)
    // if (sequence == 'four') {
    //   console.log("This is for last logout calculation");
    //   diff = this.calculateTime(index, 'logIn', 'lunchStart')
    //   let diff2 = this.calculateTime(index, preTime, currentTime)
    //   this.updateTimeValue(index, diff, diff2, true)
    //   console.log("After calculate diff", diff, diff2);
    // }
  }

  setMinimumTime(index, preTime, currentTime, minTime, sequence) {
    console.log("Here curernt time", preTime, currentTime, minTime);

    let element = this.Days[index]
    if (element.nightShift) {
      console.log("SIngle element to check", element[preTime], element[currentTime]);
      if (currentTime == 'lunchEnd' && (element[currentTime].split(":")[0] <= element[preTime].split(":")[0] || element[currentTime].split(":")[1] >= element[preTime].split(":")[1])) {
        console.log(element[currentTime], '<', element[preTime]);
        this.Days[index][minTime] = element[currentTime]
      }
      else if (currentTime == 'lunchEnd' && (element[currentTime].split(":")[0] >= element[preTime].split(":")[0] || element[currentTime].split(":")[1] < element[preTime].split(":")[1])) {
        console.log(element[currentTime], '>', element[preTime]);
        this.Days[index][minTime] = '00:00'
      }
      else if (currentTime == 'lunchStart' && element[currentTime] != null && element[currentTime].split(":")[0] < element[preTime].split(":")[0]) {
        console.log(element[currentTime], '<', element[preTime]);
        this.Days[index][minTime] = element[currentTime]
      }
      else if (currentTime == 'lunchStart' && element[currentTime] != null && element[currentTime].split(":")[0] > element[preTime].split(":")[0]) {
        console.log(element[currentTime], '>', element[preTime]);
        this.Days[index][minTime] = '00:00'
      }
      else if (element[preTime] != null && element[currentTime] == null) {
        console.log(element[currentTime], 'NOT NULL', element[preTime], 'NULL');
        this.Days[index][minTime] = '00:00'
      }
      else if (element[preTime] != null && element[currentTime] != null && currentTime != 'lunchEnd') {
        console.log(element[currentTime], 'NOT NULL', element[preTime], 'NOT NULL');
        this.Days[index][minTime] = '00:00'
      }
    } else {
      console.log("Without night time selected");
      if (sequence == 'first') this.Days[index][minTime] = this.Days[index][preTime]
      if (sequence != 'first' && sequence != 'four') this.Days[index][minTime] = this.Days[index][currentTime]
    }

    console.log("After element update", element);

  }

  calculateTime(index, preTime, currentTime) {
    console.log("Pre Time ", preTime, currentTime);
    let minutes
    let hours
    if (this.Days[index][preTime] != null && this.Days[index][currentTime] != null) {
      let startTime = this.Days[index][preTime];
      console.log("CalculateDiff 1", this.Days[index]);
      let startHours = startTime.split(":")[0]
      let startMinutes = startTime.split(":")[1]
      let endTime = this.Days[index][currentTime];
      let endHours = endTime.split(":")[0]
      let endMinutes = endTime.split(":")[1]
      let date = moment(this.Days[index].date);

      let time1: any
      let time2: any
      let difference


      if (this.Days[index].nightShift) {
        if (endHours >= startHours && endHours <= 23) {
          console.log("What is endHours", endHours, startHours);
          time1 = new Date(date.toDate().setHours(startHours, startMinutes));
          time2 = new Date(date.toDate().setHours(endHours, endMinutes));
        } else {
          // console.log("What is endHours", endHours, startHours);
          time1 = new Date(date.toDate().setHours(startHours, startMinutes));
          let tempDate = moment(this.Days[index].date, "MM-DD-YYYY").add(1, "days")
          time2 = new Date(tempDate.toDate().setHours(endHours, endMinutes));
        }
      } else {
        time1 = new Date(date.toDate().setHours(startHours, startMinutes)) //new Date(date + ' ' + startTime + ':00 GMT+0000');
        time2 = new Date(date.toDate().setHours(endHours, endMinutes))//new Date(date + ' ' + endTime + ':00 GMT+0000');
      }
      console.log("What time", time1, time2);

      difference = (time2 - time1) / 60000;
      console.log("Difference", difference);
      if (difference < 0) return ({ hours: 0, minutes: 0 })
      else
        minutes = difference % 60;
      console.log("minutes", minutes);
      hours = (difference - minutes) / 60;
      console.log("hours", hours);
      return ({ hours: hours, minutes: minutes })
    } else {
      return ({ hours: 0, minutes: 0 })
    }
  }

  updateTimeValue(index, diff, diff2?, flag?) {

    console.log("CALL this index", index);


    // console.log("Diff", diff, "diff22222", diff2, flag);
    let hoursWorking
    let totalMinute
    if (flag) {
      console.log("Flag Value", flag);
      hoursWorking = diff.hours + diff2.hours
      totalMinute = diff.minutes + diff2.minutes
      console.log("Here the total minute", totalMinute, diff.minutes, diff2.minutes);
    }
    else {
      console.log("Call this how much time", 'Test');
      hoursWorking = diff.hours;
      totalMinute = diff.minutes
    }
    console.log("hoursWorking else ", hoursWorking, totalMinute)
    if (totalMinute > 60) {
      totalMinute = totalMinute % 60;
      console.log("--IN ELSE IF--totalMinute", totalMinute, Math.ceil(totalMinute / 60));
      hoursWorking = hoursWorking + Math.ceil(totalMinute / 60)
      console.log("--IN ELSE IF--hoursWorking", hoursWorking);
      this.Days[index].workingHours.hours = hoursWorking;
      this.Days[index].workingHours.minutes = totalMinute;
    }
    else if (totalMinute == 60) {
      console.log("Second Else");

      this.Days[index].workingHours.hours = hoursWorking + 1;
      this.Days[index].workingHours.minutes = totalMinute - 60;
    }
    else {
      console.log("Last else");

      this.Days[index].workingHours.hours = hoursWorking;
      this.Days[index].workingHours.minutes = totalMinute;
    }
    console.log("After Update", this.Days[index]);

    this.totalWorkingHours();
    this.calcOverTime();

  }



  closedTravelTime(index) {
    if (this.Days[index].travel != null && this.Days[index].travel.split(":")[0] == 24) {
      console.log("Call this Part");
      this.Days[index].travel = "00:" + this.Days[index].travel.split(":")[1]
    }
    this.totalWorkingHours()
  }





  closed(index, control?) {

    this.setMinTime(index, control)



    if (this.Days[index].logIn != '00:00' && this.Days[index].lunchStart != '00:00' && this.Days[index].lunchEnd != '00:00' && this.Days[index].logOut != '00:00') {
      console.log('%c FIRST ONE ', 'background: #222; color: #bada55');

      let diff1 = this.calculateDiff1(index)
      let diff2 = this.calculateDiff2(index)
      let hoursWorking = diff1.hours + diff2.hours
      console.log("-----hoursWorking-----", hoursWorking);
      let totalMinute = diff1.minutes + diff2.minutes
      console.log("-----totalMinute-----", totalMinute);
      if (totalMinute > 60) {
        // tempWeeklyHours = tempWeeklyHours + Math.floor(tempWeeklyMinutes / 60)
        // tempWeeklyMinutes = tempWeeklyMinutes % 60
        totalMinute = totalMinute % 60;
        console.log("-----total Minutes----", totalMinute);
        console.log("-----total Minutes/60----", totalMinute / 60);
        console.log("--IN IF--totalMinute", totalMinute);
        hoursWorking = hoursWorking + Math.floor(totalMinute / 60)
        console.log("--IN IF--hoursWorking", hoursWorking);
        this.Days[index].workingHours.hours = hoursWorking;
        this.Days[index].workingHours.minutes = totalMinute;
      }
      else if (totalMinute == 60) {
        this.Days[index].workingHours.hours = hoursWorking + 1;
        this.Days[index].workingHours.minutes = totalMinute - 60;
      }
      else {
        this.Days[index].workingHours.hours = hoursWorking;
        this.Days[index].workingHours.minutes = totalMinute;
      }
      this.totalWorkingHours();
      this.calcOverTime();
    }
    else if (this.Days[index].logIn != '00:00' && this.Days[index].lunchStart != '00:00') {
      console.log('%c Oh SECOND ONE ', 'background: #222; color: #bada55');

      let diff1 = this.calculateDiff1(index)
      let hoursWorking = diff1.hours
      let totalMinute = diff1.minutes
      console.log("hoursWorking else ", diff1)
      if (totalMinute > 60) {
        // totalMinute = totalMinute - 60;
        // hoursWorking = hoursWorking + 1
        totalMinute = totalMinute % 60;
        console.log("--IN ELSE IF--totalMinute", totalMinute);
        hoursWorking = hoursWorking + Math.floor(totalMinute / 60)
        console.log("--IN ELSE IF--hoursWorking", hoursWorking);

        this.Days[index].workingHours.hours = hoursWorking;
        this.Days[index].workingHours.minutes = totalMinute;
      }
      else if (totalMinute == 60) {
        this.Days[index].workingHours.hours = hoursWorking + 1;
        this.Days[index].workingHours.minutes = totalMinute - 60;
      }
      else {
        this.Days[index].workingHours.hours = hoursWorking;
        this.Days[index].workingHours.minutes = totalMinute;
      }
      this.totalWorkingHours();
      this.calcOverTime();
    }
    else if (this.Days[index].lunchEnd != '00:00' && this.Days[index].logOut != '00:00') {
      console.log('%c THIRD ONE ', 'background: #222; color: #bada55');
      let diff2 = this.calculateDiff2(index)
      let hoursWorking = diff2.hours
      let totalMinute = diff2.minutes
      console.log(" hoursWorking else ", hoursWorking)
      if (totalMinute > 60) {
        // totalMinute = totalMinute - 60;
        // hoursWorking = hoursWorking + 1
        totalMinute = totalMinute % 60;
        console.log("**IN else IF**totalMinute", totalMinute);
        hoursWorking = hoursWorking + Math.floor(totalMinute / 60)
        console.log("**IN else IF**hoursWorking", hoursWorking);

        this.Days[index].workingHours.hours = hoursWorking;
        this.Days[index].workingHours.minutes = totalMinute;

      } else if (totalMinute == 60) {
        this.Days[index].workingHours.hours = hoursWorking + 1;
        this.Days[index].workingHours.minutes = totalMinute - 60;
      }
      else {
        this.Days[index].workingHours.hours = hoursWorking;
        this.Days[index].workingHours.minutes = totalMinute;
      }
      this.totalWorkingHours();
      this.calcOverTime();
    }
    else if (this.Days[index].logIn != '00:00' && this.Days[index].lunchStart == '00:00' && this.Days[index].lunchEnd == '00:00' && this.Days[index].nightShift) {
      console.log("This is for 12 o clock caluclation");
      let diff3 = this.calculateDiff3(index, control)
      let hoursWorking = diff3.hours
      let totalMinute = diff3.minutes
      console.log(" hoursWorking else ", hoursWorking)
      if (totalMinute > 60) {
        // totalMinute = totalMinute - 60;
        // hoursWorking = hoursWorking + 1
        totalMinute = totalMinute % 60;
        console.log("**IN else IF**totalMinute", totalMinute);
        hoursWorking = hoursWorking + Math.floor(totalMinute / 60)
        console.log("**IN else IF**hoursWorking", hoursWorking);

        this.Days[index].workingHours.hours = hoursWorking;
        this.Days[index].workingHours.minutes = totalMinute;

      } else if (totalMinute == 60) {
        this.Days[index].workingHours.hours = hoursWorking + 1;
        this.Days[index].workingHours.minutes = totalMinute - 60;
      }
      else {
        this.Days[index].workingHours.hours = hoursWorking;
        this.Days[index].workingHours.minutes = totalMinute;
      }
      this.totalWorkingHours();
      this.calcOverTime();
    }
  }



  setMinTime(index, control?) {
    console.log("THis is the index", index);
    console.log('Closed Function', this.Days[index], control);
    let element = this.Days[index]
    let loginTime = element.logIn.split(":")[0]
    let lunchStartTime = element.lunchStart.split(":")[0]
    let lunchEndTime = element.lunchEnd.split(":")[0]
    if (element.nightShift) {
      if (element.logIn != '00:00' && element.lunchEnd == '00:00') element.lunchSTime = '00:00'
      if (element.logIn != '00:00' && element.lunchStart != '00:00') {
        console.log("First If CAlled");

        if (lunchStartTime > loginTime && lunchStartTime <= 23) element.lunchETime = '00:00'
        else element.lunchETime = element.lunchStart
      }
      if (element.logIn != '00:00' && element.lunchStart != '00:00' && element.lunchEnd != '00:00') {
        console.log("Second If CAlled");
        if (lunchEndTime > lunchStartTime && lunchEndTime >= 23) element.logTime = '00:00'
        else element.logTime = element.lunchEnd
      }
      if (element.logIn != '00:00' && element.lunchStart == '00:00') element.lunchETime = '00:00'
    } else {
      console.log("LAST If CAlled");
      if (element.logIn != '00:00' && element.lunchEnd == '00:00') element.lunchSTime = element.logIn
      if (element.logIn != '00:00' && element.lunchStart != '00:00') element.lunchETime = element.lunchStart
      if (element.logIn != '00:00' && element.lunchStart != '00:00' && element.lunchEnd != '00:00') element.logTime = element.lunchEnd
    }
    console.log("After element is update", element);

    // if (control == 'lunchEnd' && this.Days[index].nightShift) this.Days[index].minTime = '00:00'
    // if (control == 'lunchEnd' && !this.Days[index].nightShift) this.Days[index].minTime = this.Days[index].lunchEnd
  }

  totalWeekHours(index) {
    console.log('Calculating Total Week Hours');
  }

  travelPlusWork(event, index) {
  }

  calculateTravelPlusWorkHours(index) {
    // console.log("***calculateTravelPlusWorkHours called", this.Days[index]);
    let travel, totalHr, totalMin;
    travel = this.Days[index].travel.split(":")
    totalHr = this.Days[index].workingHours.hours + Number(travel[0])
    // console.log("totalHr", totalHr);
    totalMin = this.Days[index].workingHours.minutes + Number(travel[1])
    // console.log("totalMin", totalMin);
    if (totalMin > 60) {
      // totalMin = totalMin - 60;
      // totalHr = totalHr + 1
      totalHr = totalHr + Math.floor(totalMin / 60)
      totalMin = totalMin % 60
      this.Days[index].totalHours.hours = totalHr;
      this.Days[index].totalHours.minutes = totalMin;
      if (totalHr < 10) { totalHr = '0' + totalHr }
      if (totalMin < 10) { totalMin = '0' + totalMin }
      // this.checkTravelPlusWorkHour(index)
      return totalHr + ":" + totalMin;
    } else if (totalMin == 60) {
      totalHr = totalHr + 1
      totalMin = totalMin - 60
      this.Days[index].totalHours.hours = totalHr;
      this.Days[index].totalHours.minutes = totalMin;
      if (totalHr < 10) { totalHr = '0' + totalHr }
      if (totalMin < 10) { totalMin = '0' + totalMin }
      // this.changeDetector.detectChanges();
      // this.checkTravelPlusWorkHour(index)
      return totalHr + ":" + totalMin;
    }
    else {
      this.Days[index].totalHours.hours = totalHr;
      this.Days[index].totalHours.minutes = totalMin;
      if (totalHr < 10) { totalHr = '0' + totalHr }
      if (totalMin < 10) { totalMin = '0' + totalMin }
      // this.changeDetector.detectChanges();
      // this.checkTravelPlusWorkHour(index)
      return totalHr + ":" + totalMin;
    }

    // if (this.Days[index].totalHours.hours)
  }

  calcOverTime() {
    // console.log("calcOverTime")
    let totalH = 0;
    let totalM = 0;
    _.forEach(this.Days, (day) => {
      // console.log("calcOverTime in forEach loop")
      // console.log("day.workingHours.hours", day.workingHours.hours);
      if (day.workingHours.hours > 11) {
        // console.log("calcOverTime in if");
        totalH = totalH + day.workingHours.hours - 12
        // console.log("calcOverTime in if totalH", totalH);
        totalM = totalM + day.workingHours.minutes
        // console.log("calcOverTime in if totalM", totalM);
      }
    })
    if (totalM > 60) {
      // console.log("Minutes > 60");
      totalH = totalH + Math.floor(totalM / 60)
      // console.log("totalH = ", totalH + Math.floor(totalM / 60));
      totalM = totalM % 60
      // console.log("totalM = ", totalM % 60);
      // return totalM;
    } else if (totalM == 60) {
      // console.log("Minutes == 60");
      totalH = totalH + 1
      // console.log("totalH = ", totalH);
      totalM = totalM - 60
      // console.log("totalM", totalM);
      // return this.overM;
    }
    else {
      this.overTime = totalH.toString() + ':' + totalM.toString();
      // return this.overM;
    }
    totalH = this.pad(totalH);
    totalM = this.pad(totalM);
    // console.log("what is total hours plus minutes", totalH, totalM);

    this.overTime = totalH.toString() + ':' + totalM.toString();
    // console.log("what is the over time hours", this.overTime);

    return totalH.toString() + ':' + totalM.toString()
  }

  pad(value) {
    if (value < 10) {
      return '0' + value;
    } else {
      return value;
    }
  }


  totalWeekHour() {
    let totalH = 0;
    let totalM = 0;
    _.forEach(this.Days, (day) => {
      totalH = totalH + day.totalHours.hours
      totalM = totalM + day.totalHours.minutes
    })
    if (totalM > 60) {
      totalH = totalH + Math.floor(totalM / 60)
      totalM = totalM % 60
      // return totalM;
    } else if (totalM == 60) {
      this.overH = this.overH + 1
      totalM = totalM - 60
      this.overM = totalM;
      // return this.overM;
    }
    else {
      this.overM = totalM;
      // return this.overM;
    }
    totalH = this.pad(totalH)
    totalM = this.pad(totalM)
    return totalH.toString() + ':' + totalM.toString()
  }


  calculateTravelPlusWorkMinutes(index) {
    let travel, totalHr, totalMin;
    travel = this.Days[index].travel.split(":")
    totalHr = this.Days[index].workingHours.hours + Number(travel[0])
    totalMin = this.Days[index].workingHours.minutes + Number(travel[1])
    if (totalMin > 60) {
      // totalMin = totalMin - 60;
      // totalHr = totalHr + 1
      totalHr = totalHr + Math.floor(totalMin / 60)
      totalMin = totalMin % 60
      this.Days[index].totalHours.minutes = totalMin;
      return totalMin;
    }
    else if (totalMin == 60) {
      totalHr = totalHr + 1
      totalMin = totalMin - 60
      this.Days[index].totalHours.minutes = totalMin;
      return totalMin;
    }
    else {
      this.Days[index].totalHours.minutes = totalMin;
      return totalMin;
    }
  }

  totalWorkingHours() {
    // console.log("this.Days", this.Days);
    // console.log('call After Api call for single week part');
    let totalH = 0;
    let totalM = 0;
    _.forEach(this.Days, (day, index) => {
      totalH = totalH + day.workingHours.hours;
      totalM = totalM + day.workingHours.minutes;
      day['totalTravelNWork'] = this.calculateTravelPlusWorkHours(index)
    })
    if (totalM > 60) {
      totalH = totalH + Math.floor(totalM / 60)
      totalM = totalM % 60
      this.totalHoursWorked.hours = totalH;
      this.totalHoursWorked.minutes = totalM;
      // this.checkTravelPlusWorkHour()
    } else if (totalM == 60) {
      this.totalHoursWorked.hours = totalH + 1;
      this.totalHoursWorked.minutes = totalM - 60
    }
    else {
      this.totalHoursWorked.hours = totalH;
      this.totalHoursWorked.minutes = totalM;
    }
    // console.log('This.totalHoursWorked', this.totalHoursWorked);
  }

  calculateWorkHours(index) {
    let date2 = moment(this.Days[index].date).format('MM/DD/YYYY');
  }

  calculateDiff1 = (index) => {
    let startTime = this.Days[index].logIn;
    console.log("CalculateDiff 1", this.Days[index]);
    let startHours = startTime.split(":")[0]
    let startMinutes = startTime.split(":")[1]
    let endTime = this.Days[index].lunchStart;
    let endHours = endTime.split(":")[0]
    let endMinutes = endTime.split(":")[1]
    let date = moment(this.Days[index].date);

    let time1: any
    let time2: any
    let difference
    let minutes
    let hours

    if (this.Days[index].nightShift) {
      if (endHours > startHours && endHours <= 23) {
        time1 = new Date(date.toDate().setHours(startHours, startMinutes));
        time2 = new Date(date.toDate().setHours(endHours, endMinutes));
      } else {
        time1 = new Date(date.toDate().setHours(startHours, startMinutes));
        let tempDate = moment(this.Days[index].date, "MM-DD-YYYY").add(1, "days")
        time2 = new Date(tempDate.toDate().setHours(endHours, endMinutes));
      }
    } else {
      time1 = new Date(date.toDate().setHours(startHours, startMinutes)) //new Date(date + ' ' + startTime + ':00 GMT+0000');
      time2 = new Date(date.toDate().setHours(endHours, endMinutes))//new Date(date + ' ' + endTime + ':00 GMT+0000');
    }
    difference = (time2 - time1) / 60000;
    console.log("Difference", difference);
    minutes = difference % 60;
    console.log("minutes", minutes);
    hours = (difference - minutes) / 60;
    console.log("hours", hours);
    return ({ hours: hours, minutes: minutes })
  }

  calculateDiff2 = (index) => {
    let startTime = this.Days[index].lunchEnd;
    console.log("CalculateDiff 2", this.Days[index]);
    let startHours = startTime.split(":")[0]
    let startMinutes = startTime.split(":")[1]
    let endTime = this.Days[index].logOut;
    let endHours = endTime.split(":")[0]
    let endMinutes = endTime.split(":")[1]
    let date = moment(this.Days[index].date);
    let time1: any
    let time2: any
    let difference
    let minutes
    let hours
    if (this.Days[index].nightShift) {
      console.log("This is for night shift");
      // let time1: any = new Date(date.toDate().setHours(startHours, startMinutes));
      console.log("Here Console endTime and endminutes", endHours, endMinutes);
      if (endHours > startHours && endHours <= 23) {
        time1 = new Date(date.toDate().setHours(startHours, startMinutes));
        time2 = new Date(date.toDate().setHours(endHours, endMinutes));
      } else {
        time1 = new Date(date.toDate().setHours(startHours, startMinutes));
        let tempDate = moment(this.Days[index].date, "MM-DD-YYYY").add(1, "days")
        time2 = new Date(tempDate.toDate().setHours(endHours, endMinutes));
      }
    } else {
      time1 = new Date(date.toDate().setHours(startHours, startMinutes));
      // console.log("***");
      console.log("--time 1--", time1);
      time2 = new Date(date.toDate().setHours(endHours, endMinutes));
      console.log("--time 2--", time2);
    }
    difference = (time2 - time1) / 60000;
    console.log("THis is the difference", difference);
    minutes = difference % 60;
    console.log("minutes", minutes);
    hours = (difference - minutes) / 60;
    console.log("hours", hours);
    return ({ hours: hours, minutes: minutes })
  }

  calculateDiff3(index, control) {
    console.log("Here is the 12 clock calculated", this.Days[index], control);
    let element = this.Days[index]
    let startTime
    let startHours
    let startMinutes
    let endTime
    let endHours
    let endMinutes
    let difference
    let minutes
    let hours
    let time1: any
    let time2: any
    let date = moment(this.Days[index].date);
    if (control == 'lunchStart') {
      startTime = this.Days[index].logIn;
      startHours = startTime.split(":")[0]
      startMinutes = startTime.split(":")[1]
      endTime = this.Days[index].lunchStart;
      endHours = endTime.split(":")[0]
      endMinutes = endTime.split(":")[1]
      time1 = new Date(date.toDate().setHours(startHours, startMinutes));
      let tempDate = moment(this.Days[index].date, "MM-DD-YYYY").add(1, "days")
      time2 = new Date(tempDate.toDate().setHours(endHours, endMinutes));
    }
    difference = (time2 - time1) / 60000;
    console.log("THis is the difference", difference);
    minutes = difference % 60;
    // console.log("minutes", minutes);
    hours = (difference - minutes) / 60;
    console.log("hours", hours, ":", minutes);
    return ({ hours: hours, minutes: minutes })

  }

  copyCurrentLogs(i) {
    this.copiedIndex = i;
    this.showPasteBtn = true
  }
  pasteLogs(i) {
    this.showPasteBtn = false
    let newLogs = this.Days[i]
    newLogs.logIn = this.Days[this.copiedIndex].logIn;
    newLogs.lunchStart = this.Days[this.copiedIndex].lunchStart;
    newLogs.lunchEnd = this.Days[this.copiedIndex].lunchEnd;
    newLogs.logOut = this.Days[this.copiedIndex].logOut;
    newLogs.travel = this.Days[this.copiedIndex].travel
    newLogs.nightShift = this.Days[this.copiedIndex].nightShift
    newLogs.lunchSTime = this.Days[this.copiedIndex].nightShift
    newLogs.lunchETime = this.Days[this.copiedIndex].lunchETime
    newLogs.logTime = this.Days[this.copiedIndex].logTime
    // this.closed(i)
    let diff = this.calculateTime(i, 'logIn', 'lunchStart')
    let diff2 = this.calculateTime(i, 'lunchEnd', 'logOut')
    this.updateTimeValue(i, diff, diff2, true)
    $('#' + this.currentPage + i).addClass('make-blue')
    this.editedIndex.push({ currentPage: this.currentPage, index: i })
    // this.edit(i,this.currentPage)
    console.log("THIS.DAYS", this.Days);
  }



  getValuesUsingDates(number?) {
    console.log("What is the dates of week", number, this.datesOfWeek);

    this.loading = true
    if (this.datesOfWeek) { this.regularHours = this.datesOfWeek.length * 12 }
    console.log('Get Values Using Dates');
    let data = {
      date: this.datesOfWeek,
      instructorId: this.instructorId,
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
    }
    console.log('%cGETTING TIME LOGS FUNCTION CALLED', "color:red;font-weight:bold")
    console.table(data)
    if (data.date && data.instructorId) {
      this._timeSheetService.getTimeLogUsingDates(data).subscribe(res => {
        console.log('Inside Res===========>>>>', res);
        this.arrayFromDb = res;
        this.editing = false
        this.index = null
        this.loading = false


        console.log('Arrayform db', this.arrayFromDb);
        this.mergeAndCompareBothArrays();
      }, error => {

      })
    }
  }



  mergeAndCompareBothArrays() {
    console.log('this.datesOfWeek=========>>>', this.datesOfWeek);
    let filterDates;
    return new Promise((resolve, reject) => {
      filterDates = this.datesOfWeek.filter(o => !this.arrayFromDb.find(o2 => o === o2.date))
      // console.log('Fiter Dates===>>>>', filterDates);
      _.forEach((filterDates), (singleDate, index) => {
        let newObj;
        newObj = {
          date: singleDate,
          _id: 'new',
          logIn: '00:00',
          lunchStart: null,
          lunchEnd: null,
          logOut: null,
          workingHours: {
            hours: 0,
            minutes: 0,
          },
          travel: '00:00',
          totalHours: {
            hours: 0,
            minutes: 0,
          },
          nightShift: false,
          logTime: '',
          lunchSTime: '',
          lunchETime: ''
        }
        this.arrayFromDb.push(newObj);
      })
      resolve(this.arrayFromDb)
    }).then((resolvedArray: any) => {
      this.arrayFromDb = (resolvedArray.sort(function (a, b) {
        return <any>new Date(b.date) - <any>new Date(a.date);
      })).reverse();
      this.Days = this.arrayFromDb;
      this.updateData(this.Days);
      this.totalWorkingHours();
      this.calcOverTime()
    })
  }

  resetCurrentLogs(index) {
    console.log('Reset Logs here:', index)
    this.Days[index].logIn = '00:00';
    this.Days[index].lunchStart = '00:00';
    this.Days[index].lunchEnd = '00:00';
    this.Days[index].logOut = '00:00';
    this.Days[index].travel = '00:00';
    this.Days[index].workingHours.hours = 0;
    this.Days[index].workingHours.minutes = 0;
    this.Days[index].totalHours.hours = 0;
    this.Days[index].totalHours.minutes = 0;
    this.Days[index].nightShift = false
    this.Days[index].reset = true;
    this.Days[index].lunchSTime = "";
    this.Days[index].lunchETime = "";
    this.Days[index].logTime = "";

    if (this.Days[index]._id && this.Days[index]._id != 'new') {
      this.deletedLog.push(this.Days[index]._id)
    }

    console.log('Deleted Logs==>', this.deletedLog);

    this.totalWorkingHours();
    this.calcOverTime();
  }

  submitDetail() {
    _.forEach((this.Days), (singleDate, index) => {
      if (singleDate.updated) this.finalArray.push(singleDate);
    })
    let data = {
      date: this.finalArray,
      deletedLog: this.deletedLog,
      instructorId: this.instructorId
    }
    console.log('finalArray===========>>>>>>', this.finalArray);
    this._timeSheetService.addTime(data).subscribe((res) => {
      this.finalArray = [];
      this.getValuesUsingDates('test6')
      this.openSnackBar("Logs added successfully!", "OK")
    }, err => {

    })
  }

  checkTotalWorkHour(hours, minutes) {
    // console.log("***checkTotalWorkHour", hours, minutes);
    if (hours > 11 && minutes > 0) {
      // console.log("***checkTotalWorkHour", "hours", hours, "minutes", minutes);
      return 'break';
    } if (hours == 12 && minutes == 0) {
      return 'ok';
    }
    else {
      return 'ok';
    }
  }


  checkTravelPlusWorkHour(index) {

    let travel, totalHr, totalMin;
    // travel = this.Days[index].travel.split(":")
    totalHr = this.Days[index].totalHours.hours
    totalMin = this.Days[index].totalHours.minutes
    // // console.log("**********totalMin", totalMin);

    if (totalHr < 14) return 'ok';
    else if (totalHr == 14 && totalMin >= 1) return 'break'
    else if (totalHr == 14 && totalMin == 0) return 'ok'
    else return 'break';
  }

  checkTotalWorkingHours(hours) {
    if (this.showTotalHoursColor == true) {
      if (hours >= 72) return 'break';
      else return 'ok';
    }
    else return 'ok';
    // console.log('Check Total Working Hours===>>>', hours);

  }
  edit(i, pageEvent) {
    this.Days[i]['updated'] = true
    if (pageEvent && pageEvent.pageIndex) {
      this.currentPage = pageEvent.pageIndex
    }
    else { this.currentPage = 0 }
    console.log("On edit adding class to", '#' + this.currentPage + i);
    $('#' + this.currentPage + i).addClass('make-blue')
    console.log("index", i);
    this.index = i
    this.editedIndex.push({ currentPage: this.currentPage, index: i })
    console.log("in edit this.editedIndex", this.editedIndex);
    this.editing = true
    console.log("**CURRENT PAGE", this.currentPage);

  }
  pageNext(event) {
    this.editing = false
    this.index = null
    console.log("**event", event);
    console.log("**this.editedIndex", this.editedIndex);
    this.currentPage = event.pageIndex;
    if (this.editedIndex) {
      this.editedIndex.forEach(i => {
        console.log("i", i);
        if (this.currentPage == i.currentPage) {
          console.log("adding class to", '#' + i.currentPage.toString() + i.index.toString());
          $(document).ready(function () {
            console.log("ready!");
            $('#' + i.currentPage.toString() + i.index.toString()).addClass('make-blue')

          });
        }
      })
    }
  }
  save(i) {
    // console.log("index", i);
    this.index = null;
    this.editing = false
  }
  getInstructorTimeLogs(datesArray, instructorId) {
    let data = {
      date: datesArray,
      instructorId: instructorId
    }
    console.log("****data", data);
    if (data.date) {
      console.log("data.date is found", data.date);
      this._timeSheetService.getTimeLogUsingDates(data).subscribe(res => {
        console.log('Res========>>>>>', res);
        this.editing = false
        this.index = null
        this.loading = false
        this.updateData(res)
      }, err => {
        console.log('Hanle Error===>', err);
      })
    }
  }

  printAdminReportB() {
    this.loading = true;
    let data = {
      logs: this.Days,
      periodStart: this.periodStart,
      periodEnd: this.periodEnd,
      instDetails: {
        name: this.instName,
        email: this.instEmail
      },
      totalWeekHours: this.totalWeekHour(),
      totalHoursWorked: this.totalHoursWorked,
      overTime: this.overTime,
      regularHours: this.regularHours,
    }
    console.log('Print Report B======>', data);
    this._timeSheetService.generatePdfReportB(data).subscribe(res => {
      console.log('Success Response', res);
      this.saveToFileSystem(res)
    }, err => {
      console.log('Error while pdf', err);
      this.loading = false;
    })
  }

  private saveToFileSystem(response) {
    let byteArray = new Uint8Array(response.data);
    let blob = new Blob([byteArray], { type: 'application/pdf' });
    saveAs(blob, 'report');
    this.loading = false;
  }


  public printsingleWeekReport() {
    this.loading = true;
    let data = {
      logs: this.Days,
      periodStart: this.datesOfWeek[0],
      periodEnd: this.datesOfWeek[this.datesOfWeek.length - 1],
      totalWeekHours: this.totalWeekHour(),
      totalHoursWorked: this.totalHoursWorked,
      overTime: this.overTime,
      regularHours: this.regularHours,
    }
    console.log('Print Single Week Report ======>', data);
    this._timeSheetService.generateWeekReport(data).subscribe(res => {
      console.log('Success Response', res);
      this.saveToFileSystem(res)

    }, err => {
      console.log('Error while pdf', err);
      this.loading = false;
    })
  }
}